/* Armazém 11/2026 — bolinha de contagem dos Curtidos (❤ no cabeçalho e na barra inferior).
   Lê localStorage.reels_likes (gravado pelo feed de vídeos e pela página Curtidos; aqui só LIDO).
   Atualiza quando o feed/página avisam (evento 'reels:likes') ou outra aba grava (evento 'storage'). */
(function () {
  if (window.__curtidosBadge) return;
  window.__curtidosBadge = true;
  function total() {
    try {
      var o = JSON.parse(localStorage.getItem('reels_likes'));
      return o && typeof o === 'object' && !Array.isArray(o) ? Object.keys(o).length : 0;
    } catch (e) {
      return 0;
    }
  }
  function paint() {
    var n = total();
    document.querySelectorAll('[data-curtidos-count]').forEach(function (el) {
      el.textContent = n > 99 ? '99+' : String(n);
      el.classList.toggle('is-cart-empty', n === 0);
    });
  }
  paint();
  document.addEventListener('reels:likes', paint);
  window.addEventListener('storage', function (e) {
    if (!e.key || e.key === 'reels_likes') paint();
  });
  window.addEventListener('pageshow', paint);
})();
